import script from "./AddTransferStudentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTransferStudentComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddTransferStudentComponent.vue?vue&type=style&index=0&id=23402885&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23402885"]])

export default __exports__